import lazyWithSuspenseAndRetry from 'modules/common/lazyWithSuspenseAndRetry';

const UppyUploaderFieldLazy = lazyWithSuspenseAndRetry(() => import('./UppyUploaderField'));

export default UppyUploaderFieldLazy;
